import { render, staticRenderFns } from "./areaMain.vue?vue&type=template&id=65107a47&scoped=true"
import script from "./areaMain.vue?vue&type=script&lang=js"
export * from "./areaMain.vue?vue&type=script&lang=js"
import style0 from "./areaMain.vue?vue&type=style&index=0&id=65107a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65107a47",
  null
  
)

export default component.exports